import { ComponentProps, FC, MouseEventHandler } from 'react'
import { styled } from '../../../lib/stitches'
import { IconButton } from '../../core/Components'
import * as Icons from '../../core/icons'
import withTooltip from '../../core/withTooltip'

const ICON_STYLE = { width: '17px', height: '17px' }
const SoloOnIcon = styled(Icons.SoloOn, ICON_STYLE)
const SoloOffIcon = styled(Icons.SoloOff, ICON_STYLE)

type SoloButtonProps = ComponentProps<typeof IconButton> & {
  solo: () => void
  unsolo: () => void
  isSelected: boolean
}

const IconButtonWithTooltip = withTooltip(IconButton)

const SoloButton: FC<SoloButtonProps> = ({ solo, unsolo, isSelected, ...props }) => {
  const handleClick: MouseEventHandler<HTMLButtonElement> = (evt) => {
    evt.stopPropagation()
    isSelected ? unsolo() : solo()
  }
  return (
    <IconButtonWithTooltip
      onClick={handleClick}
      active={isSelected}
      tooltipText={'Toggle Solo Mode'}
      {...(props as any)}
    >
      {isSelected ? <SoloOnIcon /> : <SoloOffIcon />}
    </IconButtonWithTooltip>
  )
}

export default SoloButton
